import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import Helmet from 'react-helmet'
import {Grid} from 'react-bootstrap'
import {Breadcrumb} from '../../core/react/router'
import {Loader} from '../../core/redux/loading'
import extract from '../../core/extract'
import i18n from '../i18n'
import TicketSearchBar from './TicketSearchBar'

class TicketLayout extends Component {
    static propTypes = {
    }

    render() {
    	const {children, history, routes, params, ticket} = this.props

        const breadcrumbDisplay = (token) => {
            switch (token) {
                case ':id': return ticket.ref
                default: return extract(i18n, token)
            }
        }

        return (
            <div>
                <Helmet title='Tickets' />
                <TicketSearchBar />
                <Grid>
                    <Loader
                        exclude={[/Sent$/, /Queried$/]}>
                        <Breadcrumb
                            history={history}
                            routes={routes}
                            params={params}
                            display={breadcrumbDisplay} />
                	   {children}
                    </Loader>
                </Grid>
            </div>
        )
    }
}

TicketLayout = connect((state) => ({
    ticket: state.ticket.ticket
}))(TicketLayout)

export default TicketLayout


// WEBPACK FOOTER //
// ./lib/ticket/components/TicketLayout.js